const IDENTIFIERS_FIELDS_VALUE_MAX_LENGTH = 20;

export default IDENTIFIERS_FIELDS_VALUE_MAX_LENGTH;
